import { createContext, useContext, useRef, useState } from 'react'

/**
 * The ink pill at top centre ("Staat in de agenda en op het scherm"):
 * `role="status"`, 2.2s, animation oy-up. `useOyToast().say('…')`.
 */
const TOAST_MS = 2200

type ToastApi = { say: (text: string) => void }

const OyToastContext = createContext<ToastApi | null>(null)

export function OyToastProvider({ children }: { children: React.ReactNode }) {
	const [toast, setToast] = useState<{ id: number; text: string } | null>(null)
	const timer = useRef<number | null>(null)
	const seq = useRef(0)
	const api = useRef<ToastApi>({
		say(text) {
			if (timer.current) window.clearTimeout(timer.current)
			seq.current += 1
			setToast({ id: seq.current, text })
			timer.current = window.setTimeout(() => setToast(null), TOAST_MS)
		},
	})
	return (
		<OyToastContext.Provider value={api.current}>
			{children}
			{/* the live region stays mounted so the announcement is reliable */}
			<div className="oy-toast-region" role="status" aria-live="polite">
				{toast ? (
					<div key={toast.id} className="oy-toast">
						{toast.text}
					</div>
				) : null}
			</div>
		</OyToastContext.Provider>
	)
}

export function useOyToast(): ToastApi {
	const api = useContext(OyToastContext)
	if (!api) {
		throw new Error('useOyToast needs an OyToastProvider above it')
	}
	return api
}
